// extracted by mini-css-extract-plugin
export default {"container":"NewMessageView_container__jy6EU"};